"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MappedQuery = exports.Query = exports.Comparisons = void 0;
exports.Comparisons = {
    '==': function (attribute, value) { return function (attributes) { return attributes[attribute] == value; }; },
    '===': function (attribute, value) { return function (attributes) { return attributes[attribute] === value; }; },
    '!=': function (attribute, value) { return function (attributes) { return attributes[attribute] != value; }; },
    '>': function (attribute, value) { return function (attributes) { return attributes[attribute] > value; }; },
    '<': function (attribute, value) { return function (attributes) { return attributes[attribute] < value; }; },
};
var Query = /** @class */ (function () {
    function Query(base, $filter) {
        if ($filter === void 0) { $filter = function () { return true; }; }
        this.base = base;
        this.$filter = $filter;
        this.results = [];
        this.refreshables = [];
        this.refresh();
    }
    Query.prototype.make = function (filter) {
        return new this.constructor(this.results, filter);
    };
    Query.prototype.filter = function (filter) {
        var instance = this.make(filter);
        this.refreshables.push(instance);
        return instance;
    };
    Query.prototype.where = function (attribute, comparison, value) {
        if (!(comparison in exports.Comparisons)) {
            throw new Error('Unknown comparison: ' + comparison);
        }
        return this.filter(exports.Comparisons[comparison](attribute, value));
    };
    Query.prototype.raw = function () {
        return this.results;
    };
    Query.refresh = function (from, to) {
        var e_1, _a, e_2, _b;
        try {
            for (var to_1 = __values(to), to_1_1 = to_1.next(); !to_1_1.done; to_1_1 = to_1.next()) {
                var item = to_1_1.value;
                if (from.indexOf(item) < 0) {
                    to.splice(to.indexOf(item), 1);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (to_1_1 && !to_1_1.done && (_a = to_1.return)) _a.call(to_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        try {
            for (var from_1 = __values(from), from_1_1 = from_1.next(); !from_1_1.done; from_1_1 = from_1.next()) {
                var item = from_1_1.value;
                if (to.indexOf(item) < 0) {
                    to.push(item);
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (from_1_1 && !from_1_1.done && (_b = from_1.return)) _b.call(from_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
    };
    Query.prototype.refresh = function () {
        var e_3, _a;
        var refreshed = this.base.filter(this.$filter);
        this.constructor.refresh(refreshed, this.results);
        try {
            for (var _b = __values(this.refreshables), _c = _b.next(); !_c.done; _c = _b.next()) {
                var refreshable = _c.value;
                refreshable.refresh();
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_3) throw e_3.error; }
        }
    };
    return Query;
}());
exports.Query = Query;
var MappedQuery = /** @class */ (function (_super) {
    __extends(MappedQuery, _super);
    function MappedQuery(base, filter, forwards, backwards) {
        var _this = _super.call(this, base, filter) || this;
        _this.forwards = forwards;
        _this.backwards = backwards;
        _this.mapped = [];
        _this.initialized_mapped = true;
        _this.refreshMapped();
        return _this;
    }
    MappedQuery.prototype.get = function () {
        return this.mapped;
    };
    MappedQuery.prototype.make = function (filter) {
        return new this.constructor(this.results, filter, this.forwards, this.backwards);
    };
    MappedQuery.prototype.refreshMapped = function () {
        var e_4, _a, e_5, _b;
        var _this = this;
        try {
            for (var _c = __values(this.mapped), _d = _c.next(); !_d.done; _d = _c.next()) {
                var mapped = _d.value;
                if (this.results.indexOf(this.backwards(mapped)) < 0) {
                    this.mapped.splice(this.mapped.indexOf(mapped), 1);
                }
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_4) throw e_4.error; }
        }
        var originals_from_mapped = this.mapped.map(function (mapped) { return _this.backwards(mapped); });
        try {
            for (var _e = __values(this.results), _f = _e.next(); !_f.done; _f = _e.next()) {
                var original = _f.value;
                if (originals_from_mapped.indexOf(original) < 0) {
                    this.mapped.push(this.forwards(original));
                }
            }
        }
        catch (e_5_1) { e_5 = { error: e_5_1 }; }
        finally {
            try {
                if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
            }
            finally { if (e_5) throw e_5.error; }
        }
    };
    MappedQuery.prototype.refresh = function () {
        _super.prototype.refresh.call(this);
        if (this.initialized_mapped) {
            this.refreshMapped();
        }
    };
    return MappedQuery;
}(Query));
exports.MappedQuery = MappedQuery;
